import { render, staticRenderFns } from "./email-tree.vue?vue&type=template&id=05c12a84&scoped=true&"
import script from "./email-tree.vue?vue&type=script&lang=js&"
export * from "./email-tree.vue?vue&type=script&lang=js&"
import style0 from "./email-tree.vue?vue&type=style&index=0&id=05c12a84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c12a84",
  null
  
)

export default component.exports